import React, {useEffect, useState} from "react";
import Layout from "../components/Layout";
import AssessmentInfoCard from "../components/AssessmentInfoCard";
import axios from "axios";
import {BASE_URL} from "../utils/commonUrl";
import {useSelector} from "react-redux";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import QuarterNames from "../components/QuarterNames";

const MyIdp = () =>{
    const [userAssessmentInfo, setUserAssessmentInfo] = useState([]);
    const [userCompetencyInfo, setUserCompetencyInfo] = useState([]);
    const [userMatrixData, setUserMatrixData] = useState([]);
    const [iDPEmployeeGridData, setIDPEmployeeGridData] = useState([])
    const [start] = useState(0);
    const { user } = useSelector((state) => state["auth"]);
    const [quarterName, setQuarterName] = useState("");

    useEffect(()=>{
        // userAssessmentInformation(user.registerID, user.quarterID);
        // userAssessmentInformation(user.registerID, user.quarterID);
        // userCompetencyInformation(user.registerID, user.quarterID);
        // getUserMatrixData(user.registerID, user.quarterID);
        GetAllInformation(user.registerID, user.quarterID);
        setQuarterName(user.quarterName);
    },[])

    const GetAllInformation=(registerId,quarterID)=>{
        const data = {registerId:registerId,quarterID:quarterID};

        axios.post(BASE_URL + "/api/EmployeeMatrix/GetUserMatrixData", JSON.stringify(data))
            .then((response) => {
                if (response.status === 200) {
                    setUserMatrixData(response.data);
                }
            })
            .catch((e) => {
                console.log(e);
            });


            axios.post(BASE_URL+"/api/idp/GetIDPEmployeeGridData",JSON.stringify(data))
            .then(response=>{
                setIDPEmployeeGridData(response.data)
            })
            .catch(console.log)


            axios.post(BASE_URL + "/api/utility/UserAssesmentInfromation/",JSON.stringify(data))
            .then((response) => {
                if (response.status === 200) {
                    setUserAssessmentInfo(response.data);
                }
            })
            .catch((e) => {
                console.log(e);
            });

            axios.post(BASE_URL + "/api/utility/UserCompetencyInfromation/",JSON.stringify(data))
            .then((response) => {
                if (response.status === 200) {
                    setUserCompetencyInfo(response.data);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    };

    // const getUserMatrixData = (registerId,quarterID) =>{        
    //     axios
    //         .get(BASE_URL + "/api/EmployeeMatrix/GetUserMatrixData/" + registerId)
    //         .then((response) => {
    //             if (response.status === 200) {
    //                 setUserMatrixData(response.data);
    //             }
    //         })
    //         .catch((e) => {
    //             console.log(e);
    //         });
    // }

    // const GetIDPEmployeeGridData = (id,quarterID) =>{
    //     axios.get(BASE_URL+`/api/idp/GetIDPEmployeeGridData/${id}`)
    //         .then(response=>{
    //             setIDPEmployeeGridData(response.data)
    //         })
    //         .catch(console.log)
    // }

    // const userAssessmentInformation = (id,quarterID) => {
    //     axios
    //         .get(BASE_URL + "/api/utility/UserAssesmentInfromation/" + id)
    //         .then((response) => {
    //             if (response.status === 200) {
    //                 setUserAssessmentInfo(response.data);
    //             }
    //         })
    //         .catch((e) => {
    //             console.log(e);
    //         });
    // };

    const headerTemplate = (data) => {
        return (
            <span className="image-text"><b>{data.title}</b></span>
        );
    }

    // const userCompetencyInformation = (id,quarterID) => {
    //     axios
    //         .get(BASE_URL + "/api/utility/UserCompetencyInfromation/" + id)
    //         .then((response) => {
    //             if (response.status === 200) {
    //                 setUserCompetencyInfo(response.data);
    //             }
    //         })
    //         .catch((e) => {
    //             console.log(e);
    //         });
    // };

    const childToParent = () => {
        var e = document.getElementById("ddlQuarter");
        var _selectedValue = e.value==="-1"?user.quarterID:e.value;
        setQuarterName(e.value==="-1"?user.quarterName:e.options[e.selectedIndex].text);
        GetAllInformation(user.registerID, _selectedValue);
      }

    return (
      <Layout>
           <div className="card" style={{padding:"0.3rem 1rem .3rem 1rem"}}>
                <div className="card-header">
                    <div className="row">
                        <div className="col-2">
                            <h6><i class="bi bi-person-lines-fill"></i> My IDP</h6>
                        </div>
                        <div className="col-6">
                            <h4 style={{fontSize:"1rem"}}>
                            <i class="bi bi-shield-fill-check"></i> {quarterName}
                            </h4>
                        </div>
                        <div className="col-4">
                            <QuarterNames childToParent={childToParent}/>
                    </div>
                    </div>
                </div>
           </div>
          <AssessmentInfoCard
              title={<span style={{ color: "#FFA500", textTransform: "uppercase" }}>
                <b>CORE VALUES</b>
              </span>}
              smallTitle={""}>
              <table className="table">
                  <thead>
                  <tr>
                      <th scope="col" className="tdHeaderGroupStart" colSpan={2}>Values</th>
                      <th scope="col" className="tdHeaderGroup" colSpan={3}>Self</th>
                      <th scope="col" className="tdHeaderGroupEnd" colSpan={3}>Supervisor</th>
                  </tr>
                  <tr>
                      <th scope="col">Name</th>
                      <th scope="col" className="tdHeaderGroup">RCL</th>
                      <th scope="col">Opinion</th>
                      <th scope="col" className="tdHeaderGroup">Mark</th>
                      <th scope="col" className="tdHeaderGroup">Gap</th>
                      <th scope="col">Opinion</th>
                      <th scope="col" className="tdHeaderGroup">Mark</th>
                      <th scope="col" className="tdHeaderGroup">Gap</th>
                  </tr>
                  </thead>
                  <tbody>
                  {userAssessmentInfo.map((value, index) => (
                      <tr key={index}>
                          <td>{value.assestmentName}</td>
                          <td className="tdWhiteSpace tdCenter">{value.rca}</td>
                          <td>{value.selfOpinion}</td>
                          <td className="tdCenter">{value.selfAssesmentMark}</td>
                          <td className="tdCenter">{value.selfGap}</td>
                          <td>{value.supervisorOpinion}</td>
                          <td className="tdCenter">{value.supervisorAssesmentMark}</td>
                          <td className="tdCenter">{value.supervisorGap}</td>
                      </tr>
                  ))}
                  <tr>
                      <td colSpan={3} className="tdCenter"><b>Total</b></td>
                      <td colSpan={1} className="tdCenter"><b>{userAssessmentInfo.length === 0 ? "": userAssessmentInfo.map(item => Number(item.selfAssesmentMark)).reduce((prev, next) => prev + next)}</b></td>
                      <td colSpan={1} className="tdCenter"><b>{userAssessmentInfo.length === 0 ? "": userAssessmentInfo.map(item => Number(item.selfGap)).reduce((prev, next) => prev + next)}</b></td>
                      <td/>
                      <td colSpan={1} className="tdCenter"><b>{userAssessmentInfo.length === 0 ? "": userAssessmentInfo.map(item => Number(item.supervisorAssesmentMark)).reduce((prev, next) => prev + next)}</b></td>
                      <td colSpan={1} className="tdCenter"><b>{userAssessmentInfo.length === 0 ? "": userAssessmentInfo.map(item => Number(item.supervisorGap)).reduce((prev, next) => prev + next)}</b></td>
                  </tr>
                  </tbody>
              </table>
          </AssessmentInfoCard>


          <AssessmentInfoCard
              title={
                  <span style={{ color: "#eb4034", textTransform: "uppercase" }}>
                <b>Core Competency</b>
              </span>
              }
              smallTitle={""}>
              <table className="table">
                  <thead>
                  <tr>
                      <th scope="col" className="tdHeaderGroupStart" colSpan={2}>Competency</th>
                      <th scope="col" className="tdHeaderGroup" colSpan={3}>Self</th>
                      <th scope="col" className="tdHeaderGroupEnd" colSpan={3}>Supervisor</th>
                  </tr>
                  <tr>
                      <th scope="col">Name</th>
                      <th scope="col" className="tdHeaderGroup">RCL</th>
                      <th scope="col">Opinion</th>
                      <th scope="col" className="tdHeaderGroup">Mark</th>
                      <th scope="col" className="tdHeaderGroup">Gap</th>
                      <th scope="col">Opinion</th>
                      <th scope="col" className="tdHeaderGroup">Mark</th>
                      <th scope="col" className="tdHeaderGroup">Gap</th>
                  </tr>
                  </thead>
                  <tbody>
                  {userCompetencyInfo.map((value, index) => (
                      <tr key={index}>
                          <td>{value.competencyName}</td>
                          <td className="tdWhiteSpace tdCenter">{value.rca}</td>
                          <td>{value.selfOpinion}</td>
                          <td className="tdCenter">{value.selfAssesmentMark}</td>
                          <td className="tdCenter">{value.selfGap}</td>
                          <td>{value.supervisorOpinion}</td>
                          <td className="tdCenter">{value.supervisorAssesmentMark}</td>
                          <td className="tdCenter">{value.supervisorGap}</td>
                      </tr>
                  ))}
                  <tr>
                      <td colSpan={3} className="tdCenter"><b>Total</b></td>
                      <td colSpan={1} className="tdCenter"><b>{userCompetencyInfo.length === 0 ? "": userCompetencyInfo.map(item => Number(item.selfAssesmentMark)).reduce((prev, next) => prev + next)}</b></td>
                      <td colSpan={1} className="tdCenter"><b>{userCompetencyInfo.length === 0 ? "": userCompetencyInfo.map(item => Number(item.selfGap)).reduce((prev, next) => prev + next)}</b></td>
                      <td colSpan={1}/>
                      <td colSpan={1} className="tdCenter"><b>{userCompetencyInfo.length === 0 ? "": userCompetencyInfo.map(item => Number(item.supervisorAssesmentMark)).reduce((prev, next) => prev + next)}</b></td>
                      <td colSpan={1} className="tdCenter"><b>{userCompetencyInfo.length === 0 ? "": userCompetencyInfo.map(item => Number(item.supervisorGap)).reduce((prev, next) => prev + next)}</b></td>
                  </tr>
                  </tbody>
              </table>
          </AssessmentInfoCard>


          <AssessmentInfoCard
              title={
                  <span style={{ color: "#eb4034", textTransform: "uppercase" }}>
                <b>Skill Will Matrix</b>
              </span>
              }
              smallTitle={""}>
              <table className="table">
                  <thead>
                  <tr>
                      <th scope="col">Name</th>
                      <th scope="col">Opinion</th>
                      <th scope="col" className="tdHeaderGroup">Will</th>
                      <th scope="col" className="tdHeaderGroup">RCL</th>
                      <th scope="col" className="tdHeaderGroup">Mark</th>
                      <th scope="col" className="tdHeaderGroup">Gap</th>
                  </tr>
                  </thead>
                  <tbody>
                  {userMatrixData.map((value, index) => (
                      <tr key={index}>
                          <td className="tdWhiteSpace">{value.matrixTitle}</td>
                          <td className="tdWhiteSpace">{value.supervisorOpinion}</td>
                          <td className="tdCenter">{value.willValue}</td>
                          <td className="tdCenter">{value.rca}</td>
                          <td className="tdCenter">{value.opinionValue}</td>
                          <td className="tdCenter">{value.supervisorGap}</td>
                      </tr>
                  ))}
                 <tr>
                  <td colSpan={3} className="tdCenter"><b>Total</b></td>
                  <td colSpan={1} className="tdCenter"><b>{userMatrixData.length === 0 ? "": userMatrixData.map(item => Number(item.rca)).reduce((prev, next) => prev + next)}</b></td>
                  <td colSpan={1} className="tdCenter"><b>{userMatrixData.length === 0 ? "": userMatrixData.map(item => Number(item.opinionValue)).reduce((prev, next) => prev + next)}</b></td>
                  <td colSpan={1} className="tdCenter"><b>{userMatrixData.length === 0 ? "": userMatrixData.map(item => Number(item.supervisorGap)).reduce((prev, next) => prev + next)}</b></td>
                </tr>
                  </tbody>
              </table>
          </AssessmentInfoCard>
          
          <div className="card mt-4 mb-4">
                <div className="card-header">
                    <div className="row">
                        <div className="col-md-12">
                            <h6>IDP Information</h6>
                        </div>
                    </div>

                </div>
                <div className="card-body divIDPDetails">
                    <DataTable value={iDPEmployeeGridData}  rows={7} first={start}
                                rowGroupMode="subheader" groupRowsBy="title"
                               paginatorTemplate="PageLinks" rowGroupHeaderTemplate={headerTemplate}>
                        <Column field='assesmentCompetencyName' header="Assessment Name"/>
                        <Column field='actionFromTime' header="From"/>
                        <Column field='activeToTime' header="To"/>
                        <Column field='status' header="Status"/>
                        <Column field='supervisorComments' header="Supervisor Comments"/>
                        <Column field='employeeComments' header="Employee Comments"/>
                        <Column field='exceptionalScoreComments' header="Exceptional Score Comments"/>
                    </DataTable>
                </div>
            </div>
      </Layout>
    )
}

export default MyIdp